module.exports = __webpack_public_path__ + "./assets/img_kaostation_color__0664fceb475af7f55b24ed922bd728cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_kaostation_color.jpg
// module id = 612
// module chunks = 12